// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Date from "../../../../util/Date.js";
import * as Buhta_cabinet__Keychain from "../../../../grpc/Keychain.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__LoadingSpinner from "../../../atoms/LoadingSpinner.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import CloseSvg from "static/icons/close.svg";

function make(name) {
  return function (value) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("label", {
                        children: name,
                        className: "block text-sm leading-5 text-gray-500"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("p", {
                              children: value,
                              className: "text-base leading-5"
                            }),
                        className: "mt-1 sm:mt-0 sm:col-span-2"
                      })
                ],
                className: "sm:grid sm:grid-cols-5 sm:gap-4 items-center md:grid-cols-8 lg:grid-cols-10"
              });
  };
}

function CredentialItem$InfoSectionItem(Props) {
  return make(Props.name)(Props.value);
}

const InfoSectionItem = {
  make: CredentialItem$InfoSectionItem
};

function CredentialItem(Props) {
  let id = Props.id;
  const func = Buhta_cabinet__Keychain.CredentialService.view;
  const match = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._3(func, param, {
                      hd: "username",
                      tl: {
                        hd: "password",
                        tl: {
                          hd: "memo",
                          tl: /* [] */0
                        }
                      }
                    }, id);
        }), undefined);
  const dispatch = match[1];
  const model = match[0];
  React.useEffect((function () {
          Curry._2(dispatch, undefined, undefined);
        }), [id]);
  if (typeof model === "string") {
    return JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {
                className: "animate-fadeIn"
              });
  }
  if (model.NAME === "Data") {
    const item = model.VAL;
    const org = item.org;
    return JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                title: "",
                leftActions: {
                  hd: JsxRuntime.jsx("button", {
                        children: JsxRuntime.jsx(CloseSvg, {}),
                        onClick: (function (param) {
                            Buhta_cabinet__Route.navigateTo({
                                  TAG: /* Admin */7,
                                  _0: {
                                    TAG: /* Keychain */0,
                                    _0: {
                                      TAG: /* Credentials */1,
                                      _0: /* List */0
                                    }
                                  }
                                });
                          })
                      }),
                  tl: /* [] */0
                },
                rightActions: {
                  hd: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                        size: "s",
                        kind: "default",
                        onClick: (function (param) {
                            Buhta_cabinet__Route.navigateTo({
                                  TAG: /* Admin */7,
                                  _0: {
                                    TAG: /* Keychain */0,
                                    _0: {
                                      TAG: /* Credentials */1,
                                      _0: {
                                        TAG: /* Edit */1,
                                        _0: id
                                      }
                                    }
                                  }
                                });
                          }),
                        children: "Редактировать"
                      }),
                  tl: /* [] */0
                },
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                              className: "mb-6 text-default-gray",
                              children: "Учетные данные"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Предприятие",
                                      value: org !== undefined ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                              route: {
                                                TAG: /* Admin */7,
                                                _0: {
                                                  TAG: /* Orgs */1,
                                                  _0: /* Org */{
                                                    _0: org.id,
                                                    _1: /* Dashboard */0
                                                  }
                                                }
                                              },
                                              className: "mt-0",
                                              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "hover:text-primary-lite text-links",
                                                    children: org.name
                                                  })
                                            }) : null
                                    }),
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Название",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: item.name
                                          })
                                    }),
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Логин",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: item.username !== "" ? item.username : "—"
                                          })
                                    }),
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Пароль",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: item.password !== "" ? item.password : "—"
                                          })
                                    }),
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Пометка",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: item.memo !== "" ? item.memo : "—"
                                          })
                                    }),
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Сайт",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: item.website
                                          })
                                    }),
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Тег",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: item.tag
                                          })
                                    }),
                                JsxRuntime.jsx(CredentialItem$InfoSectionItem, {
                                      name: "Истекает в",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: Belt__Belt_Option.getWithDefault(Belt__Belt_Option.map(item.expire_date, Buhta_cabinet__Date.toString), "—")
                                          })
                                    })
                              ],
                              className: "flex flex-col space-y-2"
                            })
                      ],
                      className: "p-6"
                    })
              });
  }
  console.log("grpc error", model.VAL);
  return "Ошибка: " + "TODO: Unwrap grpc error";
}

const make$1 = CredentialItem;

export {
  InfoSectionItem ,
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
